// client/translation-controller.ts
import "lit";
import "rxjs";
import "../translation.js";
import { clientTranslator } from "./clientTranslator.js";
import { globalLanguageSubject } from "./languageSubject.js";
var TranslationController = class {
  constructor(host, translator = clientTranslator) {
    this.translator = translator;
    this.translate = this.translator.translate.bind(this.translator);
    (this.host = host).addController(this);
    this._startSubscription();
  }
  hostConnected() {
    this._startSubscription();
  }
  hostDisconnected() {
    this._subscription?.unsubscribe();
    this._subscription = void 0;
  }
  _startSubscription() {
    if (!this._subscription)
      this._subscription = globalLanguageSubject.subscribe((lang) => {
        this.host.requestUpdate();
      });
  }
};
export {
  TranslationController
};
